import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Layout from 'components/common/Layout';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = () => ({
  typographySubheading: {
    margin: '-1px 0 5px 0',
  },
  section: {
    position: 'relative',
    maxWidth: 800,
    padding: '0 16px',
    margin: '24px auto 0',
  },
});

const Versions = ({ classes }) => (
  <Layout variant="error">
    <Helmet>
      <title>
        {appTitle} {titleSeparator} Versions and Release Notes
      </title>
    </Helmet>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.13.3
          </Typography>
          <Typography variant="caption" align="right">
            08/20/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added 2nd level Claims table in Home Dashboard ERA stats chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated workflow state navigation buttons active design
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Order authorization auto copy to future refill orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed ERA PDF not opening from orders table claims log dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed order create patient assign page not opening
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Resubmission Code & Reference from auto copy to future refill orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Order Insurance params linked insurance check - enable updates after removing order insurance with linked params
          </Typography>

        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.13.2
          </Typography>
          <Typography variant="caption" align="right">
            08/13/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added minor ERA home dashboard design updates
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Claims table ERA PDF link not working
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.13.1
          </Typography>
          <Typography variant="caption" align="right">
            08/13/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added Home Dashboard ERA stats chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added SMS dialog in workflow 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Workflow states buttons design to always show border
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed confirmation for DX removal in order create / edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Change Claims page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added minor design updates in Insurance / Payer dialog contacts 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Archive not loading 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Reports
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.13.0
          </Typography>
          <Typography variant="caption" align="right">
            07/23/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added ERAs for claims
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Recoupment and Rebill features in collection, paid orders table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Claims Table with new data and ERAs columns
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Claim Log Dialog (from orders table) with new data and ERAs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled order creation for same HCPC S codes with same modifiers and DOS
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Phone, Fax and Email contacts lists in Payers (available from patient Insurances and Payer settings)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Fax cover and Prescription form to get data from Payer Phone, Fax and Email contacts
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Active/Inactive as switcher to dialog header in Patient Insurance create/edit dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim # and Claim Submission filters in Workflow
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated sortable table headers to all cell clickable instead of arrow-only
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed sorting not working in Claims table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Fax Cover Sheet, Prescription Form quality after multiple faxing
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.7
          </Typography>
          <Typography variant="caption" align="right">
            06/16/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added Order # column in Orders Table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Resubmission code and Reference in orders table insurances mouseover tooltip
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added duplicate patient check on patient edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Fax cover and Prescription form in General category
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated autosuggest dropdowns to focus list scroll on prev selected value if available
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Vendor not creating from Inventory Product edit dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient information edit not opening from Chart orders tab
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed PDF Edit/Preview not printing after selecting and then deselecting checkboxes
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.6
          </Typography>
          <Typography variant="caption" align="right">
            06/12/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added possibility to select multiple documents with checkboxes in left navigation for batch print in PDF edit/preview
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient SMS Notifications dialog height not adjusted when adding lines to text
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Orders Table Insurences Reimbs / Check Number order changing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Insurance Date of Accident not showing in 1500 form printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added claim submission date in orders table transmission method tooltip on order and order line level
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugifxed claim status not showing in orders table transmission method tooltip on order line level
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Auth request for metroplus add fax, phone, date
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.5
          </Typography>
          <Typography variant="caption" align="right">
            06/05/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patients Charts table not updating when filters changed fast after page load, applied globally for all pages
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Applied optimized infinite scroll and abortable api calls for all pages
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Patient Insurance Effective Date To to required if Insurance Status is set to Inactive
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.4
          </Typography>
          <Typography variant="caption" align="right">
            06/03/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added counter to all infinite scroll tables, added counter on mobile version filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Fax Cover Sheet: Attn selection from payers, prescribers, referrals with fax or phone prefill, added request date field, made Documents Specialist editable
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Fax in Settings - Payers
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Show Charge toggle in PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Eligibility Patient Name, DOB, Primary Care Provider, other data
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.3
          </Typography>
          <Typography variant="caption" align="right">
            05/26/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Enabled PDF edit/preview pages and PDF printing for mobile devices
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Prescription Form and Fax Cover PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added autosuggest component for PDF edit/preview forms
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.2
          </Typography>
          <Typography variant="caption" align="right">
            05/18/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Bugfixed orders table jumping when notes tooltip is opened
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.1
          </Typography>
          <Typography variant="caption" align="right">
            05/16/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Bugfixed missing orders coount in orders table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed dialogs content height calculation and overflow
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.12.0
          </Typography>
          <Typography variant="caption" align="right">
            05/15/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Mobile devices responsive stage 1 enabled
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Replaced all tables pagination with infinite scroll
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.11
          </Typography>
          <Typography variant="caption" align="right">
            04/23/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Bugfixed Add Inventory Stock Line not working when setting Facility State and Is Rural
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Replaced Sign Up link on Login Page with schedule a demo link
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.10
          </Typography>
          <Typography variant="caption" align="right">
            04/14/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Bugfixed Claims not transmiting ('InsuranceApi' object is not iterable)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.9
          </Typography>
          <Typography variant="caption" align="right">
            04/13/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>   
          <Typography color="secondary" gutterBottom>
            - Added Schedule multiple orders batch sign if same Patient and date-time
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Errors in Claims Table
          </Typography>        
          <Typography color="secondary" gutterBottom>
            - Added Notes from Archived Orders in Patient Chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Facility missing in 1500 Form filed 32 if saved without preview
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed “Mailing address” to “Practice Address” in Business Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed order line insurance params not deleted when values are empty
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed notifications message (speed bump) z-index under dialogs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added special Schedule orders loading schema with specific data optimizations
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added full Patient address in Schedule card
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.8
          </Typography>
          <Typography variant="caption" align="right">
            04/06/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          
          <Typography color="secondary" gutterBottom>
            - Added Users Table in Admin panel
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Periodic Tasks Table in Admin panel
          </Typography>        
          <Typography color="secondary" gutterBottom>
            - Added New Client button in Admin panel
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Archive periodic task
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Clients info data in Admin panel
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.7
          </Typography>
          <Typography variant="caption" align="right">
            03/31/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Patient Insurance Create/Edit Dialog layout: Payer Type and Order of Benefits on 2nd row,  Insurance ID and Group ID on 3rd row, Condition Date on 4th row, Effective Dates on 5th, Condition Date Type will go before Condition Date
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Patient Insurance Create/Edit Dialog “Group ID” label to change to “Claim Number” in case of Workers Comp, Auto Accident
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Patient Insurance Create/Edit Dialog Relation to Insured options to only “Self”, “Employee” for Workers Comp and Auto Accident
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Insurance View Dialog to show Special Dates
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.6
          </Typography>
          <Typography variant="caption" align="right">
            03/26/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Workers Comp and Auto accident related name, accident date, insured id claims sending 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.5
          </Typography>
          <Typography variant="caption" align="right">
            03/26/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Removed Resubmission and Original Ref Number copy to future orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed claims sending for Workers Comp and Auto Accident
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed claims sending NPI field 31
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.4
          </Typography>
          <Typography variant="caption" align="right">
            03/25/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bigfixed Payers not saving when changing Profit Percent to Default
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Disabled System Profit Percent field for regular admins - it’s available only for master admins
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.3
          </Typography>
          <Typography variant="caption" align="right">
            03/24/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Patient Insurance: added special dates for Workers Comp and Auto Accident, added Accident State for Auto Accident,
            added more options for Relation to Insured field, added autoselect Employee if Workers Comp or Self if Auto Accident,
            added autocopy Insurance ID to Group ID if it's empty and Workers Comp or Auto Accident, added warning if there is no Accident Date for Auto Accident,
            updated data transfer to Claim MD and PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Insurance Group ID and Comments to Chart Patient Profile and Insurance Information printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Payer Name wrong wrapping in Chart Patient Profile and Insurance Information printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Replaced “PECOS eligible” label with “PECOS enrolled” everywhere
          </Typography>
          <Typography color="secondary" gutterBottom>
           - Updated Signed Electronically watermark to be smaller font size and italic
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.2
          </Typography>
          <Typography variant="caption" align="right">
            03/13/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated business settings to be read-only for regular users
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added info message when user edits order and removes Insurance which has linked Reimbs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved new and clone report template Name filed in Dialog, renamed add template button to “Save as template”
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Do not override by file upload checkbox in HCPC code
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added autoupdate of SAAS HCPC codes when alba HCPC codes are updated by file upload
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Order Creation rules for same HCPCS in one order: allowed with different DOS
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.1
          </Typography>
          <Typography variant="caption" align="right">
            03/10/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed empty charge selection from fee schedule in order edit when insurance is changed
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.11.0
          </Typography>
          <Typography variant="caption" align="right">
            03/10/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Rural / Urban flag in all addresses that is autocalcualted by zip code
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added HCPC S codes prices and description separation by State, prices separation by Rural / Urban
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated logic in order creation to select prices by state and urban / rural based on patient / facility / business address
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.19
          </Typography>
          <Typography variant="caption" align="right">
            02/13/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Claim ID not showing in claims dialog from orders table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to add Prescriber, Sales, Referral directly from order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Temporary disabled Generate button in insurance usage reports
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.18
          </Typography>
          <Typography variant="caption" align="right">
            02/03/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated UI design in Order Reports, Order Reports Columns Structure, Claim Reports
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Patient Chart Insurances sorting Inactive to bottom of each order of benefits 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated CMNs printing: removed Cost, add $ sign before Charge, removed Facility name and address
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed invisible tables with sticky headers in Safari
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Orders table Total Reimbs to exclude Reims from deleted Insurances
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.17
          </Typography>
          <Typography variant="caption" align="right">
            01/27/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed blank screen when selecting order lines with non-paid subscription
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed lost payers claim md services linkage
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed payers autoupdate
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed NPI registry for prescribers with student taxonomy
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.16
          </Typography>
          <Typography variant="caption" align="right">
            01/22/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed NPI Registry search long taxonomy license limitation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Payers - Claim MD Payers linkage (claims, eligibility services missing)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.15
          </Typography>
          <Typography variant="caption" align="right">
            01/19/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Delivery Instruction Package Old Version PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated user emails to be case insensitive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Stripe email sending after every period payment
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Lines bulk update in case of status autochange with is delivered flag set
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.14
          </Typography>
          <Typography variant="caption" align="right">
            01/16/2026
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Delivery Instruction Package, Delivery & Pickup Receipt PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Order Confirmation Form PDF, Capped Rental PDF
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed non-unicode characters breaking PDF texts (problematic characters will be stripped from printing)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed order not creating with product without any stock line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed product stock line price rounding to decimal
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed stock line creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed last stock line creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed deletion of order with rejected order lines
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed NPI Registry (cases with new address formats)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed PECOS autoupdate periodic task
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed orders send to archive periodic task
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.13
          </Typography>
          <Typography variant="caption" align="right">
            12/24/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated active subscription management logic to work with new Stripe events
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.12
          </Typography>
          <Typography variant="caption" align="right">
            12/19/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Stripe Payment Dashboard events history with downloadable invoices
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added logic to prefill stripe payment page with current user email and make it read-only
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated SAAS contract
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.11
          </Typography>
          <Typography variant="caption" align="right">
            11/20/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed uncached logo image preventing PDFs from printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Changed missing delivery information notification to type info, added more explanation text which data is missing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added editable Caloric Units field to Order Create/Edit form
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated caloric unit product Orders total charge to be calculated based on caloric units
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated PDF printing of caloric unit product Orders total charge to be calculated based on caloric units
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory, Charts, Settings Users dropdown filters overlapping table header
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed wrong order lines selected in PDF printing in case of order lines number doesn’t fit in one page
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.10
          </Typography>
          <Typography variant="caption" align="right">
            11/07/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Changed Order submit button text to “Save” for copy orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Order submit button to be disabled if there are no changes
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Caloric Units display in orders table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated 1500 form printing to show Caloric Units
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Stock Line creation to profill Facility if there is only one Facility
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create Retail Price not selected if Product created directly on order page during order creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to edit/delete stock lines on client apps
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.9
          </Typography>
          <Typography variant="caption" align="right">
            11/06/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed System user appearing as author for sold stock lines on client apps
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Stock Line history dialog columns in sold rows for products with cases
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Create product / Add Inventory dialogs footer total calculated data not fitting (increased dialog width)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.8
          </Typography>
          <Typography variant="caption" align="right">
            11/05/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated SAAS Contract PDF template
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed problems related to Last Arrival Stock Line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed PDF printing fields: Tax ID, Provider First and Last Name
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory Table Cases in Stock calculated not as Integer (with dot)
          </Typography>
           <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory Stock Line history showing NaN in Quantity in Case column for lines without cases
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.7
          </Typography>
          <Typography variant="caption" align="right">
            10/29/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed patient chart information sections search dropdowns overlapping with other sections
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to delete last one in list patient resource (Prescriber, Sales, etc)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Stock Line write off
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Line can’t be deleted from old orders
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.6
          </Typography>
          <Typography variant="caption" align="right">
            10/24/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled redesigned sticky navigation, filters, headers, table headers everywhere
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated layout in Settings business general
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added logic to use Product Name as Order Line description if added product has “Use for Self Pay” or “Use for Claims” flags
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added logo display in Facilities list
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated address display in Facilities list
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added tooltips on Settings Note Categories add button
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Cases, Units per Case, Total Units in Inventory table and Stock lIne history dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Change Inventory search by Name logic to contains
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated all tables to have smaller cell paddings on smaller screens to fit more content
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed unable to edit Stock Line history item by author or admin / manager
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Logo display on PDFs (problematic files should be re-uploaded)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed PNG Logo becoming black background after upload 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Suite preventing Settings business general address from saving
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.5
          </Typography>
          <Typography variant="caption" align="right">
            10/16/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Sold stock lines not creating in Stock Line history
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.4
          </Typography>
          <Typography variant="caption" align="right">
            10/14/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory Stock Line update to refresh data in main Inventory table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed “For Claims”, “For Self Pay”, “Facility”, “Warehouse” not prefilled from Last Stock In when adding new Stock In
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.3
          </Typography>
          <Typography variant="caption" align="right">
            10/08/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added authentication logic to keep it connected if user scrolls or clicks anything on the page, not only loads or saves data
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Increased loader circle size globally
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added box with text to Payment Contract stripe loader
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Hide button in Order create/edit inventory search
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added logic to close and keep closed Order create/edit inventory search on Product create from search
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Inventory table total product Value
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed settings new HCPC code not saving
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Self Payer insurance order creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed System user assigned to stock lines on client systems
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.2
          </Typography>
          <Typography variant="caption" align="right">
            09/12/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Changed Inventory Stock Line history dialog Last Updated position to center, added icon
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Retail Price usage icons in Inventory Products table and Stock Line History dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed “Open in inventory” button if Inventory Stock Line history dialog is opened directly on Inventory page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed “+/-” collapse logic in Inventory stock line history dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Inventory Stock Line history rows edit, delete buttons to be primary color
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Name field to initial view in Inventory filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Hide “Purchase Orders” tab in Inventory
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Switched places “Units in Case” and “Cost per Case”
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Warehouse from last Stock In to Inventory Products table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated 150003 form printing to show “31” in field 23B if Patisent has Medicare Insurance
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added printing feature in Patient chart notes block
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Stripe redirect Loader on Payment Contract page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added constraint to not save NaN values to system at all
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added migration to fix NaN Charge corrupt orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory Stock Line edit only “Use for Claims”, “Use for Self Pay” checkboxes not saving
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed NaN in Self Payer Orders Charge
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Address autocomplete (Here.js API plan)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Add / Edit inventory not saved if opened Product data for edit, but didn’t change anything
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory Table sorting by Retail Price
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed missing Warehouse info in Inventory Stock Line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed last Stock Line relink if deleting current last Stock Line
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.1
          </Typography>
          <Typography variant="caption" align="right">
            09/12/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Inventory Table columns order, added Model column, removed Warehouse
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed “Condition name” to “Condition” in Product create / edit, Inventory add dialogs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved active circle icon to Product Name in Inventory table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Warehouse to Stock Line history Dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Changed Stock Line history Dialog date in 2 lines
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed  Product create / edit, Inventory add dialog Facility, Warehouse drop-downs to open up
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed filter button “New Product” to “Add Product”, changed dialog button “Create” to “Add”
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed Stock Line history Dialog “Income” to “Stock In”
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed Stock Line history Dialog “Remaining in stock” label to “Filtered quantity” if filtering applied
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed labels to Retail Unit Price, Retail Unit Profit, Medicare Unit profit, moved profit fields to right
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Disabled regular units and boxes in Add inventory dialog If last stock line was in caloric units
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added box icon image placeholder in stock line history, add inventory dialogs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved product small image previews under main image in stock line history, add inventory dialogs 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.10.0
          </Typography>
          <Typography variant="caption" align="right">
            09/11/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Retail Price to Inventory Stock Line, changed Inventory sorting logic for this field
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added “Retail Price for claims”, “Retail Price for self pay” checkboxes
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to edit product from stock line create / edit dialogs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added prefilled data to stock line create from previous stock line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added quantity in box field saved to database for caloric units stosk lines proper data storage
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added logic in Order creation to select Retail Price if it's set up with Use in Claims or Use in Self Pay checkboxes
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Inventory fields and data positions updated (Name, Serial, Vendor, Category, Condition)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Stock line calculated total data fields to dialog footer, added profit calculations
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Warehouse Location to Stock Line Level
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated labels design in Products search on Order Create page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Order Create page Products search item to be added by click
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Claim MD Status
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Home Dashboard orders line chart sections missing
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.9.2
          </Typography>
          <Typography variant="caption" align="right">
            08/06/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Optimized Database connections
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.9.1
          </Typography>
          <Typography variant="caption" align="right">
            07/31/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Reverted old blue colour palette
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Signed Electronically watermark for PDFs sign
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed 1500 and 150003 froms printing not split by order lines max number in case of not saved order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed PDFs printing background and logo sizes on wide screens
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.9.0
          </Typography>
          <Typography variant="caption" align="right">
            07/30/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Redesign Stage 1 (colour palette and global styles changed) 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Made Inventory Calories per Unit editable when entering stock line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Cost per Case, Units in Case, Cost per Unit profile from latest stock line when new stock line is created (for items with Kcal Units)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed Price to Cost everywhere in Inventory
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Settings HCPC table renamed Sale to Purchase, Reimbs to Reimbursement
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Made new clients charts PRNs to start from 0
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Data Portability Patients upload
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inventory Stock Line edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Settings Payers default Profit percent not saved
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Stripe Payment finished event not received
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed new client company address and identifiers not saved
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create wrong Charge selected if Insurance with profit percent 0 selected after page load
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed hotbases visible in admin panel
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.8.2
          </Typography>
          <Typography variant="caption" align="right">
            07/22/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added HCPC Code Create/Edit copy Description or all data between Medicare / Medicaid
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added % ending to Payer Profit Percent field
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated 1500 Form printing Patients condition fields (10) based on Payer Type and address
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Inventory Calories per Unit field to Stock line create line, set default Supply Type to Caloric Units for products with entered Calories per Unit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed Unit Price to Unit Cost in Stock line view dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Inventory Create New Stock Line default price from previous stock line
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.8.1
          </Typography>
          <Typography variant="caption" align="right">
            07/17/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added default "11" value to 150003 Form 23B field
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.8.0
          </Typography>
          <Typography variant="caption" align="right">
            07/16/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Stripe Payment Dashboard enabled
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.8
          </Typography>
          <Typography variant="caption" align="right">
            06/24/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated 150003 form Date of Service From position
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.7
          </Typography>
          <Typography variant="caption" align="right">
            06/20/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated fields/background image position in 150003 form
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to edit Date of Delivery, Time of Delivery, Place of Service, Driver for any State via special dialog in Orders Table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Facility Logo and Facility Name tooltip in Orders Table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed claim reports "Claim Submission Date" label
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.6
          </Typography>
          <Typography variant="caption" align="right">
            06/06/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Improved PDF Edit/Privew in case of many fileds
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed second page in 150003 form, updated fileds
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Disabled Capped Rental PDF
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Facility Image and Address not applied when printing form Sign dialog
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.5
          </Typography>
          <Typography variant="caption" align="right">
            06/04/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added 150003 Medicaid Form PDF
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated PDFs printing with Facility Logo and Facility address, phone etc
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed PDF signed from Schedule missing patient address and other data
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.3
          </Typography>
          <Typography variant="caption" align="right">
            05/26/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to search Users for any Role (order line assign for example)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed address and time zone not saved when creating Facility (wrong time zone validation)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.2
          </Typography>
          <Typography variant="caption" align="right">
            05/22/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Facility Logo Image in settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Meaningful file names with document types and Order # when saving signed PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled creation of new users with previously used and then deleted user email
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled delete for Master Admin, Admin and Manager roles
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled SMS Template edit / delete for author
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.1
          </Typography>
          <Typography variant="caption" align="right">
            05/13/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Notification Dashboard MMS image dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Narrative printing in 1500 form
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Primary Taxomony to SAAS onboarding
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Referral Source Contact Fax can’t be removed
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Payer Profit percent 0
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Company Identifiers and Address not saved after new SAAS client creation (Removed required from Primary Taxomony)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Notifications settings list looped in filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed SMS Notification
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed new SAAS client template email link
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.7.0
          </Typography>
          <Typography variant="caption" align="right">
            05/07/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Notifications Dashboard and Read History Type Filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Notifications Dashboard and Read History loading with pagination
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Notifications Websocket connection to Patient Chart incoming SMS
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Order # in Orders table current / future tooltip
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled Websocket and Notifications for SAAS clients
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Fax in Referral Source contacts
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added UV Loop for Notifications Websocket (performance)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Made Patient Chart Referral Source, Sales, Insurance name clickable for edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled Primary Taxonomy for Claims send
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed total Charge in Claims Dashboard (removed Units * Charge)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.6.5
          </Typography>
          <Typography variant="caption" align="right">
            04/23/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Business and Facility Identifiers Primary Taxonomy field (for Claims submisson in some cases)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed new SAAS user company setup dialog Next button disabled 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient Event Log texts for: SMS Send to Patient, DOS Reminder, Authorization Reminder, Create / Update / Delete Patient Notes
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.6.4
          </Typography>
          <Typography variant="caption" align="right">
            04/22/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Notifications Dashboard Read All full functionality
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled user text selection for links
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.6.3
          </Typography>
          <Typography variant="caption" align="right">
            04/15/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Patient Chart Prescriber search by NPI/LIC, made Prescriber name clickable for edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Notifications Dashboard Assigned and Watched filters to select from your notifications, not show other users list
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed incoming SMS
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Notifications Dashboard counters
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.6.2
          </Typography>
          <Typography variant="caption" align="right">
            04/03/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added SAAS admin panel
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added clickable design (read on click) for Notifications Dashboard items
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Notifications History icon
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Notifications Read all button (not final solution)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Notifications Dashboard front-end performance for big notifications quantity
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prior Authorization display in Orders table if Insurance Params were deleted
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Notifications seconds always 0
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.6.1
          </Typography>
          <Typography variant="caption" align="right">
            03/24/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Notifications: Order Delete, Prior Authorization expire reminder, Date of Service expire reminder
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Notifications Dashboard expand/collapse state to save (in browser session)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Notifications Dashboard date-time format with seconds
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Prior Authorization display in Orders table
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.6.0
          </Typography>
          <Typography variant="caption" align="right">
            15/03/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Notifications: Patient Create, Patient Delete, New Patient SMS sent, New Patient Document Added, Patient Document Deleted, New Patient Note Added, Patient Note Changed, Patient Note Deleted, Order Create, New Order Note Added, Order Note Changed, Order Note Deleted
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Documents attach, delete and Order Notes create, edit, delete events in Event Log
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Notifications Dashboard settings with new list of notifications, removed basic / advanced mode
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.5.1
          </Typography>
          <Typography variant="caption" align="right">
            12/03/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Receive SMS from patient event in Event Log
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Notifications Dashboard expanded scroll height
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Claims Dashboard Claim # filter not clearing table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create / Edit Authorization Datepicker overlapping text field
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create / Edit Authorization, Date can’t be cleared
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.5.0
          </Typography>
          <Typography variant="caption" align="right">
            10/03/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Notifications Dashboard History
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to expand / collapse Notifications Dashboard
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.4.0
          </Typography>
          <Typography variant="caption" align="right">
            05/03/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Order information for each order line row in orders report
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim information for each claim line row in claims report
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.3.1
          </Typography>
          <Typography variant="caption" align="right">
            03/03/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Home Dashboard Notifications Settings (All, Assigned, Watched for all types)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Websocket autorestart on error or connection close
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Websocket heartbeat to prevent closing after time
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.3.0
          </Typography>
          <Typography variant="caption" align="right">
            22/02/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Home Dashboard Notifications (Web Sockets) New Patient SMS event
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.2.3
          </Typography>
          <Typography variant="caption" align="right">
            03/02/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Order Edit Vitals to be selected from list of existing Chart Vitals at first
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Chart SMS Notifications, Notes, Order CMN icons
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Event Log to hide duplicate View events from same date and time
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Reduced empty space in Templates preview
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed blank screen on Activity log open from Charts list page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed blank screen on Notes open from Order View page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Note popup submit button to original place at bottom right
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed page scroll staying at very bottom and no content visible if rows per page changed from 100 to 10
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.2.2
          </Typography>
          <Typography variant="caption" align="right">
            24/01/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Activity Log dialog filter to stay at top on scroll
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Authorization Request documents to show Facility address
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Orders Table jumping when scrolled to very bottom
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Schedule blank screen after some time or notes open
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.2.1
          </Typography>
          <Typography variant="caption" align="right">
            21/01/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Diagnosis Expire At field
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Indication if Diagnosis Expire At field is before current date or DOS
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added HCPCS Codes, Company Information, Company Logo in Templates
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.2.0
          </Typography>
          <Typography variant="caption" align="right">
            14/01/2025
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Separated Company Settings in independent sections
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Facility data structure to be similar with Company
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Sign Up Success Dialog with initial Company set up
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added functionality to copy available Sign Up data to initial Company set up
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved Patient Activity Log speed performance
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Order ID filter in Patient Activity Log
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added separate Activity Log for each order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Activity Log blank screen in some cases
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Workflow Patient filter applied twice
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.1.1
          </Typography>
          <Typography variant="caption" align="right">
            12/12/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Sign Up link to Log In page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Check Number can't be set
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Report creation by HCPCS code
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Report can't be created with only Archive orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed "X" button in Order Edit for each Order Line removal not always showing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Primary Language flag not always showing, added more Language options
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed digits number in Sign Up SMS confirmation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed SMS confirmation expire time in minutes
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.1.0
          </Typography>
          <Typography variant="caption" align="right">
            22/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Patient Primary Language
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to set Patient Referral Source Primary Contact
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Optimized Patient Referral Source design for multiple Contacts
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to set drag and drop order for Patient Prescriber, Referral Source, Sales
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Reports to include Archive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Workflow Status Reassign
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Charts search "X" clear buttons missing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed loop to password create page for new User
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.0.3
          </Typography>
          <Typography variant="caption" align="right">
            15/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Product creation from Order create/edit - Warehouse Location, Category, Condition impossible to add new
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed redirect to last opened page after logout
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed redirect order edit with saved values after logout during order creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed home Dashboard donut chart Paid state missing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed 1500 Form PDF printing to display billing address
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.0.2
          </Typography>
          <Typography variant="caption" align="right">
            12/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added "X" remove button for each order line in Order Create/Edit page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled Prescriber, Sales, Referral edit for regular users
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed User create page button "Done" to "Create" 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create/Edit page to work with multiple OR HCPCS Codes
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create/Edit page order lines grouped by 6 (removed)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create/Edit page printing 1500 Form switch pages (sets of codes) with order lines more then 6
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed 1500 Form printing Charge NaN if more then 1000
          </Typography>   
          <Typography color="secondary" gutterBottom>
            - Bugfixed Assigned By User
          </Typography>  
          <Typography color="secondary" gutterBottom>
            - Bugfixed to run session manager from RQ on client server
          </Typography>  
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.0.1
          </Typography>
          <Typography variant="caption" align="right">
            08/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Renamed new client sign up title
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated new client email confirm with autoredirect to next step after 5 sec
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Made Twilio and Change Credentials pages unavailable for regular users
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated new client sign up with Terms of Use and Privacy Policy as links, accept error message
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed new client sign up repeat password rules
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Password Create page url and texts for new client
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Settings Workflow Statuses not showing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Address Autocomplete wrong state format
          </Typography>     
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 3.0.0
          </Typography>
          <Typography variant="caption" align="right">
            07/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - SaaS Enabled
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Eligibility crash with new Change response format
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Address Autocomplete crash with new Here.js API
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.24.1
          </Typography>
          <Typography variant="caption" align="right">
            09/09/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Removed apply to other order lines for Reimbs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled Patient search with comma
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Insurance ID filter in Workflow to be case insensitive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim # filter in Claims
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Renamed left navigation Home to Dashboard
          </Typography>    
          <Typography color="secondary" gutterBottom>
            - Bugfixed sync updates from order edit to parent page if it was opened via DOS click
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed search Order by Prescriber name
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.24.0
          </Typography>
          <Typography variant="caption" align="right">
            09/03/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Workflow Archive Orders view
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim Reports
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Twilio Credentials page for multiple phone types
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Minor Inventory updates: renamed Category Type, make caloric units default if Enteral category, linked HCPC code to product in inventory, removed In Stock filter by default
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Claim Filters
          </Typography>    
          <Typography color="secondary" gutterBottom>
            - Bugfixed Resubmission Code + changed field to select
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed not all Patient Notes showing
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.23.0
          </Typography>
          <Typography variant="caption" align="right">
            08/01/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled Workflow Archive printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Village Care Authorization Request, optimized Integra Partners type PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Template printing to take Prescriber, Vitals, Insurance, Diagnoses from Order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed sending Claims, recieving Claim errors, Claim 1500 form fields
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Settings Payers update
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Settings Payers with Claim MD relation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Eligibility PDF texts overlap
          </Typography>

          <Typography color="secondary" gutterBottom>
            - Bugfixed Watchers add users search to show only active users
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.22.0
          </Typography>
          <Typography variant="caption" align="right">
            07/19/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enabled sending Claims via Claim MD
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim Statuses page in Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Separated Claims dashboard in 2 tabs: Claim MD and Change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Refactored Claim MD Eligibility (Grouped by benefit type, all data enabled)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Alba Auth Request PDF
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Company Email in Business Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added other user Watchers Remove and Add
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed not all Workflow Filters applied
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.21.0
          </Typography>
          <Typography variant="caption" align="right">
            06/18/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Switched Payers from Change to Claim MD 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim MD settings page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled Insurance Eligibility check via Claim MD
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled Claim MD Insurance Eligibility Explain download
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.20.5
          </Typography>
          <Typography variant="caption" align="right">
            05/23/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Calories Per Unit in Product and modified Order Units calculation based on it
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Rejected display in Order Edit page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Paid state (category) in Reports
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Event Log for multiple future Orders creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to delete inventory Product Stock Line
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.20.4
          </Typography>
          <Typography variant="caption" align="right">
            05/16/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Chart Prescriber Cell Phone not saving
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.20.3
          </Typography>
          <Typography variant="caption" align="right">
            05/14/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Optimized space in Templates printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Datepicker to set focus on end date if range is selected
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed bold font from Chart emergency contact
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Event Log infinite loading on date filter change
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.20.2
          </Typography>
          <Typography variant="caption" align="right">
            04/30/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated Rejected / Undo Rejected buttons 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.20.1
          </Typography>
          <Typography variant="caption" align="right">
            04/26/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added New Event Log for Order and Order Line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Filters for New Event Log
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.9
          </Typography>
          <Typography variant="caption" align="right">
            04/03/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Line change Type to Rental if empty Insurance crashes to blank screen
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescriber, Referral, Sales "Add New" creation without linked resources from Patient Chart page
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.8
          </Typography>
          <Typography variant="caption" align="right">
            03/29/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Line Refill change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Delete
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to create Prescriber without linked Referral
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescriber linked dialog to open if you create new Prescriber from Chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Workflow filter save filters button overlapped by label tooltip and not clickable
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed blank screen on Order Lines status add if checkboxes are selected
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.7
          </Typography>
          <Typography variant="caption" align="right">
            03/27/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Workflow Orders Archive added
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Archived filter checkbox in Patient Orders added
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Settings Prescribers - Referrals - Sales linkage added
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Linked Prescribers - Referrals - Sales suggestion dialog in Chart added
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.6
          </Typography>
          <Typography variant="caption" align="right">
            03/06/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Workflow crash with delted patient order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed no Insurance in patient header if you add insurance later
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed wrong data in PDF printing (saved from previous printed patient)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed prescriber with no phone in registry error on add
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.5
          </Typography>
          <Typography variant="caption" align="right">
            03/05/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Report with Status generation
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.4
          </Typography>
          <Typography variant="caption" align="right">
            03/03/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Replaced Workflow Archive with Rejected
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Watcher and City filters switched places in Orders filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Eligibility check icon button in Chart insurances
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added indication for third party and in-app Payers services in Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added saving for updates in PDFs printing when you switch between documents
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed looped login after forgot password
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Wellcare Auth Request DX Codes printing
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.3
          </Typography>
          <Typography variant="caption" align="right">
            02/14/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Orders search requests speed performance improvement on scroll (with offset > 0)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Watcher added to Orders Filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Main left navigation links updated to open in same tab (new tab in right click menu)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.2
          </Typography>
          <Typography variant="caption" align="right">
            02/10/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Orders search requests speed performance improvement (Next Filters)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Orders filter Patient Name / PRN field updated to autosuggest for orders search speed performance improvement
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.1
          </Typography>
          <Typography variant="caption" align="right">
            02/01/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Settings Payers page update - stage 2
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed City from Order Line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Made Reimbs and Check Number fields, also some other cells visible for Paid state Order Lines
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added DOS to Schedule card lines
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed products search dropdown not closing after add click in order create page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Schedule Driver filter not applied on driver name click
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Schedule City names
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed signature dialog opened from document preview not closing without filling date
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Supplier address printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Cancel button not working sometimes on order create page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed columns alignment in orders table
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.19.0
          </Typography>
          <Typography variant="caption" align="right">
            01/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Change Payers API updated
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Settings Payers page update - stage 1
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Minor performance improvements in orders filtering
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Minor performance improvements in signature
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.18.1
          </Typography>
          <Typography variant="caption" align="right">
            01/11/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added DOD in tooltip for inactive patient
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added scroll to orders filters list in case of many items
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved performance of orders search by filtering (canceling previous requests, no request if all filters from some type applied)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.18.0
          </Typography>
          <Typography variant="caption" align="right">
            01/09/2024
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added new "Paid" Workflow State
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Chart orders filter to work similar to Workflow
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added "Select All" option in Workflow and Chart orders filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Prescriber Cell Phone field
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed blank screen on Chart page in some cases
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescriber selection from registry in case of no primary address phone
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.17.1
          </Typography>
          <Typography variant="caption" align="right">
            12/15/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed SMS
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Workflow Status reassign for orders in Archive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to Delete some orders (related to future orders chain)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.17.0
          </Typography>
          <Typography variant="caption" align="right">
            11/29/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Customizable Report Columns Structure
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Image Crop and Zoom edit in Business logo upload
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Patient name to be Last Name comma First Name everywhere
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Integra Delivery Forms
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Inventory pages navigation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated general filter design to be on white background
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved Check Numbers internal functionality
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Charge update based on Profit Percent in order create/edit on Insurance change
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.16.2
          </Typography>
          <Typography variant="caption" align="right">
            11/07/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Fixed Delivery Tickets saving/printing after Signature if no Date entered
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.16.1
          </Typography>
          <Typography variant="caption" align="right">
            11/07/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Patient Watchers to Workflow
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Note Category Active/Inactive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Note Category Batch Reassign
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Charts filter design
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled negative and decimal profit percent
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added default structure to Report template (BE only)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order create/edit message not appearing 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Reports templates not loading and on fly report generation
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.16.0
          </Typography>
          <Typography variant="caption" align="right">
            10/26/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Patient Watchers
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Separated Patient address to Billing and Delivery addresses
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Connected Note Categories to Workflow States, added Note filters by Workflow State, updated notes design
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Schedule cards design for better functionality on tablets
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Signature to Schedule cards
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Date of Delivery in Signature dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added default report structure (BE only)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed search Patients by integer Record Number
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Date of Delivery/Date of Service exception which appeared sometimes
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.15.2
          </Typography>
          <Typography variant="caption" align="right">
            10/01/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Removed diagnoses ABF/ABF check process from Claims
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed duplicate diagnoses bug (same diagnoses on different places)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed error when deleting Patient
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Duplicate key in order line (Reimbs, Reimbs Date insurance param fail without exception bug)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Line without modifiers fail
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed removing sales representative from patient
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed fail with non-linked previus order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed fail with duplicate workflow status
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.15.1
          </Typography>
          <Typography variant="caption" align="right">
            09/28/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Fixed Date of Delivery not saving if Tme of Delivery was not set (error will appear) Added Time of Delivery prefill if you select Date
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed Notifications Dashboard dates filter
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed Notifications minor UI issues
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Claims filter Date of Submission label, Total Charge in Claims table row, fixed color indication for Claims icon
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.15.0
          </Typography>
          <Typography variant="caption" align="right">
            09/11/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Improved Order Create/Edit page design to fit more information without scroll and have better UX
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed possibility to save Template
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.14.0
          </Typography>
          <Typography variant="caption" align="right">
            08/10/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Improved Notifications Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved Notifications Filters
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added buttons to save and reset Notification filters
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Notification Details (from Event Log)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added SMS text to Notification
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.13.0
          </Typography>
          <Typography variant="caption" align="right">
            07/25/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Switched Landing to separate website and url
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.12.5
          </Typography>
          <Typography variant="caption" align="right">
            07/06/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Updated HCPC S Workflow filter to have suggestions only present in Orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Eligibility validation problem
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to update Order if Patient was deleted
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to update Date of Delivery in archived Order Line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to delete some Orders
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to clear Date of Delivery
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to clear Diagnosis or Primary Diagnosis
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed sending claims in some cases
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.12.4
          </Typography>
          <Typography variant="caption" align="right">
            06/27/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added HCPC S filter in Workflow
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Notes filter in Patient Chart to show only available options
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Rental and Refill orders so previus orders will be unlinked if you delete order after them
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order and Order Line Insurance Info not changing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Date of Delivery change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Autochange Status not going to event log
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Line Diagnosis not updating after changing and saving
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Assigned From User to be properly set
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Self Payer not properly setting in Order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed for Rental and Refill orders if you change future orders to Purchase they will also be updated if you change previous Rental and Refill orders
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.12.3
          </Typography>
          <Typography variant="caption" align="right">
            06/20/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Improved Order Edit page open speed
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved Order Create/Edit page inputs speed
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved global performance of text inputs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed cursor jumping to end of the field (for example Log In page email)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.12.2
          </Typography>
          <Typography variant="caption" align="right">
            06/07/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added or fixed Notifications for: Order Create, Bulk Order Update, Order Line Edit, Order Delete, Order Reassign, Order Status Change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Authorization Date Expiration and Upcoming Future Order Notifications, including real-time Notification creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed SMS Template text limit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed incorrect Notification creation caused by wrong order of Notifications listeners
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Linked Notifications with Event Log (only BE)
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.12.1
          </Typography>
          <Typography variant="caption" align="right">
            05/30/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient Diagnosis dates not showing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Lines not going to Archive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to change Insurance in Order
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed sending Claims
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to change fields (Assigned User, Date of Delivery etc) in some O
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed duplicate Orders and wrong number of orders in Schedule for some specific dates
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Inactive Drivers orders not showing in Schedule
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed label for error message on Reimbs, Reimbs Date grouped update from different Insurances
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.12.0
          </Typography>
          <Typography variant="caption" align="right">
            05/22/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Workflow Orders Saving and Creating Performance Optimization
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to change Order Line Type after creation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed problems with future Orders when changing current Recurring or Rental Orders
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.11.5
          </Typography>
          <Typography variant="caption" align="right">
            05/08/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Removed limitation from Patient SMS
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Patient SMS Notification (if selected in Notifications settings) is send to all users, not only with assigned orders 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added counter of unread SMS in circle on Patient Chart page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Authorization Date Notification to pop up live on date update (not only in scheduled job)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Recurring Order Date of Service expires in 5 or less days Notification
          </Typography> 
          <Typography color="secondary" gutterBottom>
            - Added Last Refill Order Notification (Date of Service ending in 30 days)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Date of Delivery change SMS notification to be added in SMS Notifications Dialog on Patient Chart page
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.11.4
          </Typography>
          <Typography variant="caption" align="right">
            04/27/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed last Blog title
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Collection Reimbs, Reimbs Date, Check Number not syncing with selected checkboxes in Patient Chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Apply to other order lines popup not appearing in Chart and Workflow
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Insurance update not applied to Orders in Patient Chart
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.11.3
          </Typography>
          <Typography variant="caption" align="right">
            04/25/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed showing read notifications in Notifications Dashboard
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Authorization Date reminder notification
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed new SMS from Patient notification 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Improved notifications load speed performance
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Notifications Settings labels and added description
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.11.2
          </Typography>
          <Typography variant="caption" align="right">
            04/17/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Home Dashboard Notifications Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Home Dashboard Notifications History (with previously read Notifications)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Changed Workflow Status automove to set only next automatic Status
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed SMS Notifications Dialog open and fast close blank screen
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Orders Table checkboxes and Action Bar Select All
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Collection Reimbs, Reimbs Date, Check Number not syncing with selected checkboxes
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Eligibility PDF linebreaks
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed SMS Notifications text overlaping Save button
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed daylight saving time in all dates
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.11.1
          </Typography>
          <Typography variant="caption" align="right">
            03/23/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Refactored Web Sockets implementation (for Notifications)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated error and button texts on Patient Create page in case of duplicate
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added profit percent hints on Settings - Payers page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Active/Inactive filter not working for Order Create - Patient Assign
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Self Payer always displaying in Schedule
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescriber filter not working in Schedule
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient Credit Card autoset to default if you delete default Card
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.11.0
          </Typography>
          <Typography variant="caption" align="right">
            03/14/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Notifications on Home Dashboard (Web Sockets)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Twilio Credentials page in Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added duplicate Patient creation warning with similar charts suggestions
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Workflow Status Create/Edit Dialog Labels
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient SMS Template offset left in case of long text
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient change from Inactive to Active Status should clear Date of Death
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.10.2
          </Typography>
          <Typography variant="caption" align="right">
            03/09/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Enable Claims transmission for BAMS (all applications except DEMO) 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.10.1
          </Typography>
          <Typography variant="caption" align="right">
            02/21/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescriber creation (in case of Phone only in secondary address from registry)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to remove diagnosis in Order create/edit Order Line (in case of 4 diagnoses set)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Blog Posts
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.10.0
          </Typography>
          <Typography variant="caption" align="right">
            02/13/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Workflow Statuses management
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added multiple Workflow Statuses per order line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Blog Posts
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added updates for Orders with deleted Patient
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Self Payer display in Orders Table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Settings Payer impossible to save
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Data Portability file download
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.9.4
          </Typography>
          <Typography variant="caption" align="right">
            01/26/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added SMS Notifications Media (MMS)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added SMS Notifications Templates
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Increased Patient and Order Notes length to 1000 chars
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed dispositioned play button on Landing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Schedule to open with Delivery state tab active by default
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Home Billing to open Workflow with Billing state tab active by default
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.9.3
          </Typography>
          <Typography variant="caption" align="right">
            01/20/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Eligibility Explain Details download on fail and automatic attachment of it to Chart Documents
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Eligibility Check with empty result error message 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.9.2
          </Typography>
          <Typography variant="caption" align="right">
            01/07/2023
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added SMS Notifications feature in Patient Chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated notes in orders table and schedule to stay on click
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added hint and color on mouseover in header right navigation
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Create Order button in Chart with more visible design
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Minor Bugfixes in Schedule 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.9.1
          </Typography>
          <Typography variant="caption" align="right">
            12/18/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added full claim information in dialog opened in orders table from Workflow and Patient Chart
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Main navigation items on the left sidebar will open in new tabs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed default filter by active user if no saved filters
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed blog path from blog URLs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed no possibility to remove Saved Filters in Schedule
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed redirect to 404 if you clear all filters in Schedule
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.9.0
          </Typography>
          <Typography variant="caption" align="right">
            12/03/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Email, SMS notifications on Date of Delivery change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Changed Preferred method of communication to Email, SMS notifications toggles in Chart contact information
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Chart and Order notes design, added Author and Date of Creation filters in Patient Notes 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - New comments in Schedule printing will save to Patient Chart Notes
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Product Name will be displayed in Schedule print instead of HCPCS description
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Minor Blog Updates
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.8.0
          </Typography>
          <Typography variant="caption" align="right">
            11/15/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Two-Factor Authorization feature
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added new articles to Blog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Date of Delivery from Delivery Tickets printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Date of Delivery autopopulate on order create/edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Separated Saved Filters for Workflow and Schedule
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Claims data for Insurance that are not Self
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Payer not saving (profit percents issue)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Opened Claim Explain API calls for non-admin users
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.7.1
          </Typography>
          <Typography variant="caption" align="right">
            10/26/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescriber phone format after Find in Registry 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Patient Date of Death error on chart edit
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Check Number Reports Filter always going to email report
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Prescribers PECOS inactive database
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.7.0
          </Typography>
          <Typography variant="caption" align="right">
            10/20/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added possibility to save filters in Workflow and Schedule
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Prescriber filter in Workflow
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Check Number and Reimbs Date filters in Reports
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Short and Full explanation details in Claims
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Date of Death in Chart header, made Date of Death mandatiry if chart is set inactive
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Active/Inactive filter in Charts
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added PECOS autoupdate, PECOS Invalid option and PECOS filter in Settings - Prescribers
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Images and Categories in Product search on Order create/edit page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Activity Log with Referral, Prescriber, Sales delete events
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim Log on order level in orders table
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Claim Status fixes and errors updates
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed possibility to remove Payer address in Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed undefined Driver Name in Delivery Tickets
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.6.0
          </Typography>
          <Typography variant="caption" align="right">
            09/18/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Moved Claims to separate item in left sidebar main menu. Added Claim Lines with detailed information about each order line in Claim.
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added possibility to send Claims with Attachment. Added Attachment Log modal on Claims page (available for claims with attachments)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Address fields in Settings - Payers (for Claim Attachments)
            </Typography>
          <Typography color="secondary" gutterBottom>
            - Added New PDFs
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Settings left menu with possibility to collapse/expand
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Implemented design improvements on Chart page for better screen space usage
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Order Create/Edit Datepicker Today, This Week, This Month, etc functionality to work properly with Apply to Other Order Lines action.
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Bugfixed Authorization fields in Order Create/Edit
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.5.7
          </Typography>
          <Typography variant="caption" align="right">
            07/28/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Payment demo for Braintree
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim Details button with possibility to download explaination 
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Eligibility Details button with possibility to download explaination 
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.5.6
          </Typography>
          <Typography variant="caption" align="right">
            06/28/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Model (Copy) functionality to Role Accesses Management
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added login check on Report download from email, posibillity to authenticate
            and download file from special Download page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Facility Zip to long format
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.5.5
          </Typography>
          <Typography variant="caption" align="right">
            06/24/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Versions and Release Notes page
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Company Logo upload field in Business Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added dynamic Company Logo, Company Name, Company Address etc rendering
            in PDF Documents printing
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Moved Change settings to separate page in Business Settings and synced
            field namimg with Change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Updated Referrals with Contacts List with Contact Name, Email, Phone in each list item
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Role filter in Settings Users
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Enabled horizontal page scroll (except Schedule)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Hidden PROFIT_PERCENT from Settings System,
            fixed no-update bug with PROFIT_PERCENT in Settings Payers
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Hotjar tracking
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Hint Upload Button to images in Inventory Product Creat/Edit Dialog
          </Typography>
        </Grid>
      </Grid>
    </div>
    <div className={classes.section}>
      <Grid
        direction="row"
        container
        spacing={24}
      >
        <Grid item xs={3}>
          <Typography className={classes.typographySubheading} align="right" variant="subheading">
            Version 2.5.4
          </Typography>
          <Typography variant="caption" align="right">
            06/09/2022
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="secondary" gutterBottom>
            - Added Referral Source multiple phones
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Opened hidden with *** password fields in Comany, Facility, Settings
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Removed Profit Percent from Business (now only in System Settings and Payers)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Reorganized API endpoints for Change
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Order Create/Edit &quot;Apply All&quot; action bar updated with 2 modes:
            apply all, apply only to empty
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Printing without prescriber in order caused blank screen bug fixed
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Datepicker this month, this week will select also future days
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Added Claim Refresh button (will be shown only if claim is in progress by Change)
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Transmission Method circle with colored claim status indication added on order level
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Replaced &quot;By mail&quot; with &quot;SMS&quot; in Chart, put radiobuttons in line
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Changed Primary Phone to Self Phone, Work Phone to Emergency Contact in Chart profile
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Fixed spelling errors in Referral Create/Edit Dialog
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Made Product &quot;Is Active&quot; checkbox selected by default
          </Typography>
          <Typography color="secondary" gutterBottom>
            - Also some other minor fixes and updates
          </Typography>
        </Grid>
      </Grid>
    </div>
  </Layout>
);

Versions.propTypes = {
  classes: PropTypes.shape({
    typographySubheading: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(Versions);



// WEBPACK FOOTER //
// ./src/pages/common/Versions.js